import React from "react";
import {useDispatch} from "react-redux";
import {Avatar, Popover} from "antd";
import {userSignOut} from "appRedux/actions/Auth";

const UserInfo = ({teacher_details}) => {

  const dispatch = useDispatch();
  // const { teacher_details = {} } = useSelector(({ dashboard }) => dashboard);
  const name = teacher_details ? teacher_details.name : ""
  const userMenuOptions = (
    <ul className="gx-user-popover">
      {/* <li>My Account</li>
      <li>Connections</li> */}
      <li onClick={() => dispatch(userSignOut())}>Logout
      </li>
    </ul>
  );
  const getAvatarLetters = ()=>{
    if (!name) return ""
     return name.split(" ").map(s=>s[0]).filter(s=>s).slice(0,2).map(s=>s[0].toUpperCase()).join("")
  }
  return (
    <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={userMenuOptions}
             trigger="click">
       <Avatar className="gx-size-40 gx-pointer gx-mr-3" alt="" style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}>
              {getAvatarLetters()}
            </Avatar>
    </Popover>
  )

}

export default UserInfo;
